import configHelper from '@/config/ConfigHelper'
import { i18n } from '@/i18n'

function GenerateConfig () {
  return [
    {
      id: 'F1',
      name: i18n.t('verifactu.invoice_type.f1')
    },
    {
      id: 'F2',
      name: i18n.t('verifactu.invoice_type.f2')
    },
    {
      id: 'R1',
      name: i18n.t('verifactu.invoice_type.R1')
    },
    {
      id: 'R2',
      name: i18n.t('verifactu.invoice_type.R2')
    },
    {
      id: 'R3',
      name: i18n.t('verifactu.invoice_type.R3')
    },
    {
      id: 'R4',
      name: i18n.t('verifactu.invoice_type.R4')
    },
    {
      id: 'R5',
      name: i18n.t('verifactu.invoice_type.R5')
    },
    {
      id: 'F3',
      name: i18n.t('verifactu.invoice_type.F3')
    },
  ]
}

export function TIPOS_FACTURA (state) {
  return configHelper.getConfig(state, 'TIPOS_FACTURA', GenerateConfig)
}
